import React, { useState, useEffect } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import {db} from '../../firebase'

import ReactPlayer from "react-player";


function Notice() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
      const [showPerPage, setShowPerPage] = useState(9);
      const [pagination, setPagination] =useState({
          start: 0,
          end: showPerPage,
      });
  
      const onPaginationChange = (start,  end) =>{
          setPagination({start: start, end: end});
      };
      const [searchTerm, setsearchTerm] = useState("");
      const [notice, setNotice] = useState([])
      const navigate = useNavigate()
  
      const noticeCollectionRef = collection(db, "Notice");
      useEffect(() => {
  
          const getNotice = async () => {
              const data = await getDocs(noticeCollectionRef);
              setNotice(data.docs.map((doc) => ({...doc.data(), id: doc.id })))
          }
  
          getNotice()
      }, [])
    return (
      
<>



            {notice.filter((val)=>{
      if (setsearchTerm === ""){
        return val;
      } {
        return val;
      }
    }).slice(pagination.start, pagination.end).map((maatartafoundation) => { return (
       
            
                      

                            <div className="card-body">
                                
                                <h5 style={{color:"#125e7f"}} className="card-text"> {maatartafoundation.title}</h5>
                              


                                <h5 style={{color:"#125e7f"}} className="card-text"> {maatartafoundation.title2}</h5>

                
                    
                              
                            </div>
                           
                                )})} 
                            
                         

</>
        
        );
    }
    
    export default Notice;